import { gql } from '@apollo/client'

export const GET_ATTENDEES_LIST = gql`
    query AttendeesList(
        $guid: String!
        $limit: Int!
        $offset: Int
        $state: String
        $query: String
    ) {
        entity(guid: $guid) {
            guid
            ... on Event {
                canEdit
                attendees(
                    limit: $limit
                    offset: $offset
                    state: $state
                    query: $query
                    orderBy: timeUpdated
                    orderDirection: desc
                ) {
                    total
                    edges {
                        guid
                        icon
                        url
                        name
                        email
                        state
                        isAttendingSubEvents
                    }
                }
            }
        }
    }
`
